import './style/index.js';

import _Progress from './Progress';

export type { ProgressProps } from './Progress';
export * from './type';

export const Progress = _Progress;
export default Progress;
